import { FC } from 'react'
import { importApi } from '../../services/import.api'
import DonutChart from './DonutChart'

const TrackingChart: FC = () => {
  const { data } = importApi.useGetStatisticsQuery({})

  return !data?.importQueueTasksAmount && !data?.importQueueAmount ? null : (
    <DonutChart
      title={<div className=' text-secondary import-wide'>IMPORT</div>}
      autoPrefix
      data={[
        {
          // name: 'Errors',
          value: data?.importQueueErrorsAmount || 0,
          fill: 'var(--color-red-400)',
        },
        {
          // name: 'Passed',
          // value: (data?.importQueueAmount || 0) - (data?.importQueueTasksAmount || 0),
          value: data?.importQueueAmount || 0,
          fill: 'var(--color-secondary_hover)',
        },
        {
          // name: 'All Tasks',
          value: data?.importQueueTasksAmount || 0,
          fill: 'var(--color-gray-300)',
          fillContrast: 'black',
        },
      ]}
    />
  )
}

export default TrackingChart
